import component from './search.component';
import service from './search.service';

export default angular.module('mpdx.common.search', [component, service]).name;
